import React from 'react'
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config'
// import { useSelector } from '@/store'
// import { useHistory } from 'react-router-dom'

const PersonalAuth: React.FC<RouteConfigComponentProps<any>> = (props) => {
  const { route } = props
  // const isPersonal = useSelector((state) => state.auth?.userInfo?.isPersonal)
  // const userInfo = useSelector((state) => state.auth?.userInfo)

  // const history = useHistory()
  // if (route) {
  //   if (isPersonal) {
  //     return renderRoutes(route.routes)
  //   }

  //   // 企业用户不能访问钱包
  //   history.push('/')
  // }
  // return null

  return renderRoutes(route.routes)
}

export default PersonalAuth
